import React from "react";
import { X, ImageIcon } from "lucide-react";

/**
 * Horizontal thumbnail strip for currently-attached images.
 * `attachments` = [{ id, previewUrl }, ...]
 * `onRemove(id)` — removes a single one. Pass no onRemove to render read-only (history view).
 */
export default function AttachmentStrip({ attachments, onRemove, small = false }) {
  if (!attachments || attachments.length === 0) return null;
  const size = small ? "w-14 h-14" : "w-20 h-20";
  return (
    <div className="flex flex-wrap gap-2" data-testid="attachment-strip">
      {attachments.map((a) => (
        <div
          key={a.id}
          className={`${size} relative rounded-md overflow-hidden border border-white/10 bg-white/[0.03] group flex-shrink-0`}
          data-testid={`attachment-thumb-${a.id}`}
        >
          {a.previewUrl ? (
            <img
              src={a.previewUrl}
              alt="attachment"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-white/40">
              <ImageIcon className="w-5 h-5" />
            </div>
          )}
          {onRemove && (
            <button
              type="button"
              onClick={() => onRemove(a.id)}
              aria-label="Remove image"
              className="absolute top-1 right-1 w-5 h-5 rounded-full bg-black/70 text-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
              data-testid={`remove-attachment-${a.id}`}
            >
              <X className="w-3 h-3" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
